/* Native details remain usable if JavaScript is unavailable. */
(() => {
 const header = document.querySelector('[data-kh-header]');
 if (!header) return;
 const menus = [...header.querySelectorAll('[data-kh-menu]')];
 const close = () => header.querySelectorAll('details[open]').forEach(d => { d.open = false; });
 menus.forEach(menu => {
  menu.addEventListener('toggle', () => {
   if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
  });
 });
 document.addEventListener('pointerdown', event => { if (!header.contains(event.target)) close(); });
 header.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
   const active = event.target.closest('details[open]');
   close();
   active?.querySelector('summary')?.focus();
  }
 });
})();